var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndex8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#index8_svg__clip0_491_2876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8a8 8 0 018-8h16v16a8 8 0 01-8 8H0V8z",
    fill: "#000",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.496 10.316c.009.427.146.753.413.977.262.233.565.35.908.35.355 0 .664-.117.926-.35.258-.224.392-.55.4-.977-.008-.44-.142-.772-.4-.997a1.414 1.414 0 00-.926-.323c-.343 0-.646.108-.908.323-.267.225-.404.557-.413.997zm-1.498 3.98c.009-.893.373-1.587 1.092-2.082a2.714 2.714 0 01-.647-.832c-.182-.292-.273-.639-.273-1.04.008-.77.268-1.408.78-1.911.483-.5 1.105-.754 1.867-.762.774.008 1.407.262 1.898.762.495.503.746 1.14.755 1.91 0 .402-.083.75-.248 1.041-.173.313-.397.59-.672.832.719.495 1.083 1.189 1.091 2.082-.008.834-.281 1.5-.819 2-.545.512-1.214.772-2.005.78-.787-.008-1.446-.268-1.974-.78-.555-.5-.836-1.166-.845-2zm1.327-.013c.008.423.16.77.457 1.041.284.284.628.425 1.035.425.419 0 .77-.141 1.053-.425.288-.27.436-.618.445-1.04-.009-.432-.157-.784-.445-1.055a1.527 1.527 0 00-2.088 0c-.296.271-.449.623-.457 1.054z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "index8_svg__clip0_491_2876"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgIndex8;